/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TimeDate } from './TimeDate';
import {
    TimeDateFromJSON,
    TimeDateFromJSONTyped,
    TimeDateToJSON,
    TimeDateToJSONTyped,
} from './TimeDate';
import type { AttachedDocumentResponse } from './AttachedDocumentResponse';
import {
    AttachedDocumentResponseFromJSON,
    AttachedDocumentResponseFromJSONTyped,
    AttachedDocumentResponseToJSON,
    AttachedDocumentResponseToJSONTyped,
} from './AttachedDocumentResponse';

/**
 * 
 * @export
 * @interface CaseNoteResponse
 */
export interface CaseNoteResponse {
    /**
     * 
     * @type {string}
     * @memberof CaseNoteResponse
     */
    caseNoteId: string;
    /**
     * 
     * @type {string}
     * @memberof CaseNoteResponse
     */
    clientId: string;
    /**
     * 
     * @type {string}
     * @memberof CaseNoteResponse
     */
    type: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CaseNoteResponse
     */
    date: Date | null;
    /**
     * 
     * @type {TimeDate}
     * @memberof CaseNoteResponse
     */
    time: TimeDate | null;
    /**
     * 
     * @type {string}
     * @memberof CaseNoteResponse
     */
    assignedCounselorId: string | null;
    /**
     * 
     * @type {string}
     * @memberof CaseNoteResponse
     */
    location: string | null;
    /**
     * 
     * @type {string}
     * @memberof CaseNoteResponse
     */
    content: string | null;
    /**
     * 
     * @type {string}
     * @memberof CaseNoteResponse
     */
    result: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CaseNoteResponse
     */
    createdAtUtc: Date;
    /**
     * 
     * @type {string}
     * @memberof CaseNoteResponse
     */
    createdBy: string;
    /**
     * 
     * @type {boolean}
     * @memberof CaseNoteResponse
     */
    canDelete: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CaseNoteResponse
     */
    canEdit: boolean;
    /**
     * 
     * @type {AttachedDocumentResponse}
     * @memberof CaseNoteResponse
     */
    attachedDocument?: AttachedDocumentResponse | null;
    /**
     * 
     * @type {string}
     * @memberof CaseNoteResponse
     */
    searchHighlightTerm?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CaseNoteResponse
     */
    appointmentStatus?: string | null;
}

/**
 * Check if a given object implements the CaseNoteResponse interface.
 */
export function instanceOfCaseNoteResponse(value: object): value is CaseNoteResponse {
    if (!('caseNoteId' in value) || value['caseNoteId'] === undefined) return false;
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('time' in value) || value['time'] === undefined) return false;
    if (!('assignedCounselorId' in value) || value['assignedCounselorId'] === undefined) return false;
    if (!('location' in value) || value['location'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('result' in value) || value['result'] === undefined) return false;
    if (!('createdAtUtc' in value) || value['createdAtUtc'] === undefined) return false;
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    if (!('canDelete' in value) || value['canDelete'] === undefined) return false;
    if (!('canEdit' in value) || value['canEdit'] === undefined) return false;
    return true;
}

export function CaseNoteResponseFromJSON(json: any): CaseNoteResponse {
    return CaseNoteResponseFromJSONTyped(json, false);
}

export function CaseNoteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaseNoteResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'caseNoteId': json['caseNoteId'],
        'clientId': json['clientId'],
        'type': json['type'],
        'date': (json['date'] == null ? null : new Date(json['date'])),
        'time': TimeDateFromJSON(json['time']),
        'assignedCounselorId': json['assignedCounselorId'],
        'location': json['location'],
        'content': json['content'],
        'result': json['result'],
        'createdAtUtc': (new Date(json['createdAtUtc'])),
        'createdBy': json['createdBy'],
        'canDelete': json['canDelete'],
        'canEdit': json['canEdit'],
        'attachedDocument': json['attachedDocument'] == null ? undefined : AttachedDocumentResponseFromJSON(json['attachedDocument']),
        'searchHighlightTerm': json['searchHighlightTerm'] == null ? undefined : json['searchHighlightTerm'],
        'appointmentStatus': json['appointmentStatus'] == null ? undefined : json['appointmentStatus'],
    };
}

export function CaseNoteResponseToJSON(json: any): CaseNoteResponse {
    return CaseNoteResponseToJSONTyped(json, false);
}

export function CaseNoteResponseToJSONTyped(value?: CaseNoteResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'caseNoteId': value['caseNoteId'],
        'clientId': value['clientId'],
        'type': value['type'],
        'date': value['date'] == null ? value['date'] : `${value['date'].getFullYear()}-${String(value['date'].getMonth()+1).padStart(2,'0')}-${String(value['date'].getDate()).padStart(2,'0')}`,
        'time': TimeDateToJSON(value['time']),
        'assignedCounselorId': value['assignedCounselorId'],
        'location': value['location'],
        'content': value['content'],
        'result': value['result'],
        'createdAtUtc': value['createdAtUtc'].toISOString(),
        'createdBy': value['createdBy'],
        'canDelete': value['canDelete'],
        'canEdit': value['canEdit'],
        'attachedDocument': AttachedDocumentResponseToJSON(value['attachedDocument']),
        'searchHighlightTerm': value['searchHighlightTerm'],
        'appointmentStatus': value['appointmentStatus'],
    };
}

